import { HistoryEvent } from "./tactics.model";
export class HalfItHistoryEvent extends HistoryEvent {
    constructor(type, playerIndex, segment, pointsAdded, previousTotal) {
        super(type, playerIndex, segment);
        this.pointsAdded = pointsAdded;
        this.previousTotal = previousTotal;
    }
}
